import React from 'react';
import {
    Button,
    Icon,
    Table,
    Form,
    Header,
    Segment,
    Popup,
    Loader,
    Input,
    Tab,
    Responsive,
    Divider
} from 'semantic-ui-react';
import Modal from 'react-responsive-modal';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { fetchAcademicYears, fetchAllAcademicYears, fetchStudyType } from '../../../Lookups/util';
import {
    fetchCourses,
    fetchStudentSemesterInfo, fetchStudentSemesters,
    fetchStudentStatuses,
    fetchStudentStatusesLookup
} from '../../StudentOverview/NextSemesterEnroll';
import SimpleTwoColumnTableRow from '../../../StudentPersonalInfo/SimpleTwoColumnTableRow';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class SemesterEnrollment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentStatusesLookup: [],
            studentSemesters: [],
            currentSemesters: [],
            currentSemester: '',
            semesterOptions: [],
            studyTypes: [],
            studyType: '',
            studentStatuses: [],
            studentStatus: '',
            semesterToEnroll: '',
            requiredEcts: '',
            acquiredEcts: '',
            courses: [],
            coursesForSemester: '',
            academicYears: [],

            semesterNumOptions: [{ text: 'default' }],

            loading: true,
            open: false,
            locked: false,
            graduated: false,
            gradEnroll: false,
            showCourses: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchAcademicYearOptions = this.fetchAcademicYearOptions.bind(this);
        this.fetchSemesterOptions = this.fetchSemesterOptions.bind(this);
        this.enrollThirdCycleStudent = this.enrollThirdCycleStudent.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.fetchSemesterNumOptions = this.fetchSemesterNumOptions.bind(this);
    }

    componentDidMount() {
        this.props.fetchStudentOptions();
        this.fetchAcademicYearOptions();
        axios.get('student-statuses/to-enroll/')
            .then(res => {
                let studentStatuses = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }
                this.setState({
                    studentStatuses
                });
            });

        fetchStudyType()
            .then(res => {
                const studyTypes = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));

                this.setState({ studyTypes });
            });
    }
    fetchSemesterNumOptions(spId = null) {
        axios.get(`study-programs/study-program-semesters/${spId}`)
            .then(res => {
                this.setState({
                    semesterNumOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });
    }

    fetchSemesterOptions(academicYearId) {
        axios.get(`semester/by-academic-year/${academicYearId}/`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name.name
                    }))
                });
            });
    }

    fetchAcademicYearOptions() {
        // If early enrollment for the next academic year is currently open (semester/enrollment/ already
        // returns semesters from that year, ahead of the current one), offer all academic years; otherwise
        // only current + previous.
        axios.all([axios.get('semester/enrollment/'), axios.get('academic-years/current')])
            .then(axios.spread((currentSemRes, currentAcademicYearRes) => {
                const earlyEnrollmentOpen = currentSemRes.data.some(el => el.academicYear.id !== currentAcademicYearRes.data.id);

                (earlyEnrollmentOpen ? fetchAllAcademicYears() : fetchAcademicYears())
                    .then(res => {
                        this.setState({
                            academicYearOptions: res.data.reverse().map(el => ({
                                ...el, key: el.id, value: el.id, text: el.name
                            }))
                        });
                    });
            }));
    }

    handleInputChange(event, { name, value }) {
        if (name === 'student') {
            const studentStudyProgramId = value.id;
            this.setState({ semesterNum: null });
            this.fetchSemesterNumOptions(value.studyProgramId);
            axios.all([fetchStudentStatuses(), fetchStudentStatusesLookup(),
                fetchStudentSemesters(studentStudyProgramId), fetchStudentSemesterInfo(studentStudyProgramId), fetchCourses(studentStudyProgramId)
            ])
                .then(axios.spread((statusesRes, statusesLookupRes, studentSemRes, infoRes, coursesRes) => {
                    let studentStatuses = statusesRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }));

                    if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                        studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                    }
                    const studentStatusesLookup = statusesLookupRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }));


                    this.setState({
                        studentStatuses,
                        studentStatusesLookup,

                        loading: false,
                        semesterToEnroll: infoRes.data.semesterToEnroll !== null ? infoRes.data.semesterToEnroll.name : '',
                        requiredEcts: infoRes.data.requiredEcts !== null ? infoRes.data.requiredEcts : '',
                        acquiredEcts: infoRes.data.acquiredEcts !== null ? infoRes.data.acquiredEcts : '',
                        courses: coursesRes.data ? coursesRes.data : [],
                        locked: infoRes.data.locked,
                        graduated: infoRes.data.graduated
                    });
                }))
                .catch(err => {
                    console.log('Failed to fetch study types, student statuses or semester info...');
                });
        }

        if (name === 'academicYear') { this.setState({ semester: null }); this.fetchSemesterOptions(value); }
        this.setState({
            [name]: value
        });
    }
    enrollThirdCycleStudent() {
        let semester = this.state.currentSemesters.find(el => el.id === this.state.currentSemester);
        let obj = {
            studentStudyProgram: { id: this.state.student.id },
            studyType: { id: this.state.studyType },
            studentStatus: { id: this.state.studentStatus },
            semester: { id: this.state.semester },
            studyProgramSemester: { id: this.state.semesterNum }
        };
        axios.post('students/third-cycle-or-postgraduate-specialist/semester-enrollment/', { ...obj })
            .then(res => {
                toast('Student je uspješno upisan u semestar.');

                axios.all([fetchStudentSemesters(this.props.studentStudyProgramId)])
                    .then(axios.spread((studentSemRes) => {
                        this.setState({ studentSemesters: studentSemRes.data });
                    }))
                    .catch(err => {
                        console.log('Failed to fetch student semesters');
                    });

                this.setState({
                    studyType: null, studentStatus: null, currentSemester: null, semester: null, academicYear: null, semesterNum: null, open: false
                });
                this.resetForm();
            })
            .catch(err => {
                if (err.response.data === 'Student is already enrolled in this semester!') { toast('Student je već upisan u odabrani semestar!'); } else
                if (err.response.data === 'This is only for third cycle students!') { toast('Student nije student trećeg ciklusa!'); }
                if (err.response.data === 'Student is already enrolled as grad!') { toast('Student je upisan u apsolventski staž u odabranoj akademskoj godini!'); } else {
                    toast('Došlo je do greške! Student nije upisan u naredni semestar.');
                }
                this.setState({ open: false });
            });
    }
    resetForm() {
        this.setState({

            semester: null,
            academicYear: null,
            semesterNum: null,
            studentStatus: null,
            studyType: null

        });
    }

    render() {
        const {
            open, currentSemester, studentStatus, studentStatuses, studyType,
            studyTypes, acquiredEcts, semesterToEnroll, courses
        } = this.state;
        return (
            <div>
                <Modal
                    open={open}
                    onClose={() => this.setState({ open: false })}
                    center
                ><br />
                    <h2>Upis studenta u naredni semestar</h2>
                    <Divider />
                    <Segment color="blue" clearing>
                        <Table celled unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <SimpleTwoColumnTableRow
                                    name="Broj ECTS bodova"
                                    keyName="acquiredEcts"
                                    value={acquiredEcts}
                                />
                                {/* <SimpleTwoColumnTableRow */}
                                {/* name='Broj potrebnih ECTS bodova' */}
                                {/* keyName="requiredEcts" */}
                                {/* value={requiredEcts} */}
                                {/* disabled */}
                                {/* /> */}
                                <SimpleTwoColumnTableRow
                                    name="Semestar u koji se student upisuje"
                                    keyName="semesterToEnroll"
                                    value={this.state.semester && this.state.academicYear ? this.state.semesterOptions.find(el => el.value === this.state.semester).text + ' ' + this.state.academicYearOptions.find(el => el.value === this.state.academicYear).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Akademski semestar"
                                    keyName="currentSemester"
                                    value={this.state.semesterNum ? this.state.semesterNumOptions.find(el => el.value === this.state.semesterNum).text : ''}
                                />

                                <SimpleTwoColumnTableRow
                                    name="Status studenta"
                                    keyName="studentStatus"
                                    value={studentStatus ? studentStatuses.find(el => el.value === studentStatus).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Tip studiranja"
                                    keyName="studyType"
                                    value={studyType ? studyTypes.find(el => el.value === studyType).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Predmeti koje student prenosi"
                                    keyName="courses"
                                    value={courses.map(el => (<div>{el.courseName}<br /></div>))}
                                />
                            </Table.Body>
                        </Table>


                        <Button floated="right" color="blue" basic="true" onClick={() => this.setState({ open: false })}>Odustani</Button>
                        <Button floated="right" color="blue" onClick={this.enrollThirdCycleStudent}>Upiši studenta</Button>

                    </Segment>
                </Modal>
                {/* <Divider horizontal> */}
                {/*    <Header as='h4'> */}
                {/*        Podaci o upisu */}
                {/*    </Header> */}
                {/* </Divider> */}

                <Form>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.studentErr}>
                            <label>Student</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir studenta"
                                value={this.state.student}
                                onChange={this.handleInputChange}
                                name="student"
                                options={this.props.studentOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.academicYearErr}>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir godine"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYearOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field required error={this.state.semesterErr}>
                            <label>Semestar</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir semestra"
                                value={this.state.semester}
                                onChange={this.handleInputChange}
                                name="semester"
                                options={this.state.semesterOptions.filter(e => e.name._key !== 'other' && e.name._key !== 'summer school')}
                                search
                                disabled={!this.state.academicYear}
                                fluid
                                selection
                            />
                        </Form.Field>

                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field required>
                            <label>Broj semestra </label>
                            <Form.Dropdown
                                clearable
                                disabled={!this.state.student}
                                placeholder="Odabir semestra"
                                value={this.state.semesterNum}
                                onChange={this.handleInputChange}
                                name="semesterNum"
                                options={this.state.semesterNumOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required>
                            <label>Tip studiranja studenta</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir tipa"
                                value={studyType}
                                onChange={this.handleInputChange}
                                name="studyType"
                                options={studyTypes}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required>
                            <label>Status studenta</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir statusa"
                                value={studentStatus}
                                onChange={this.handleInputChange}
                                name="studentStatus"
                                options={studentStatuses}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                    </Form.Group>
                    <Button
                        floated="right"
                        color="blue"
                        onClick={() => {
                            if (this.state.semester && studentStatus && studyType && this.state.semesterNum) {
                                this.setState({ open: true });
                            } else toast('Niste unijeli sva obavezna polja!');
                        }}
                    >Upiši studenta</Button>
                    <br />
                    <br />
                </Form>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ThirdCycle/SemesterEnrollment/SemesterEnrollment.js